import React, { Component } from 'react';
import IconSetSection from 'components/Icon/IconSetSection';


class SectionTitle extends Component {
  render() {
    const { title, color, style, icon, align, titleSize } = this.props;
    const titleStyle = {
      color: color,
      ...(style ? style : {})
    };
    const titleTextStyle = {
      borderBottom: '1px '+color+' solid',
    }
    const bulletStyle = {
      backgroundColor: '#ffffff',
    }

    const iconSize = ['xs'].indexOf(titleSize) >= 0 ? 40 : 80;
    return (
      <h1 className="SectionTitle" style={titleStyle}>
        <If condition={(align === undefined || align === 'left') && icon !== false}><span className="bullet left" style={{ ...bulletStyle}}><IconSetSection icon={icon || 'home'} size={iconSize} /></span></If>
        <span className="titleText" style={titleTextStyle}>{title}</span>
        <If condition={align === 'right' && icon !== false}><span className="bullet right" style={{...bulletStyle}}><IconSetSection icon={icon || 'home'} size={iconSize} /></span></If>
      </h1>
    );
  }
}
export default SectionTitle;



// WEBPACK FOOTER //
// ./src/components/Home/Section/SectionTitle.jsx